<template>
    <div>
        <v-dialog
            transition="dialog-bottom-transition"
            v-model="suggestionDialog"
            max-width="700"
            scrollable
        >
            <v-card>
                <v-toolbar dense flat>
                    <v-toolbar-title>Rubriques appercu dans</v-toolbar-title>
                </v-toolbar>
                <v-divider/>
                <v-card-text>
                    <v-simple-table dense>
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th class="text-left"></th>
                                <th class="text-left">Code</th>
                                <th class="text-left">Libellé</th>
                                <th class="text-left">Formule</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in suggestions" :key="index">
                                <td>
                                    <v-btn
                                        v-if="not_in(item) && !single"
                                        class="ma-1"
                                        small
                                        color="primary"
                                        @click="add(item, true)"
                                    >
                                        <v-icon class="ma-1">mdi-plus-circle-outline</v-icon>
                                    </v-btn>
                                    <v-btn
                                        v-if="is_in(item) && !single"
                                        class="ma-1"
                                        small
                                        color="red"
                                        dark
                                        @click="selected.splice(selected.findIndex((ps) => ps.code === item.code), 1)"
                                    >
                                        <v-icon class="ma-1">mdi-minus</v-icon>
                                    </v-btn>
                                </td>
                                <td>
                                    {{ item.code }}
                                </td>
                                <td>
                                    {{ item.label }}
                                </td>
                                <td>
                                    {{ item.formule }}
                                </td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        depressed
                        dark
                        color="teal"
                        outlined
                        @click="
              () => {
                suggestionDialog = false;
                suggestions = [];
              }
            "
                    >
                        {{ $t("common.close") }}
                        <v-icon right>mdi-close</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            transition="dialog-bottom-transition"
            v-model="dialog"
            :fullscreen="fullscreen"
            persistent
            max-width="2000"
        >
            <v-card>
                <v-toolbar flat dark color="primary" dense>
                    <v-toolbar-title>
                        {{ $t("pay_section.select_pay_section") }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="fullscreen = !fullscreen">
                        <v-icon>mdi-aspect-ratio</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-container fluid>
                        <v-row>
                            <v-chip-group>
                                <v-chip
                                    label
                                    color="primary"
                                    outlined
                                    v-for="(v, i) in selected"
                                    :key="i"
                                >[{{ v.code }}] {{ v.label }}
                                </v-chip
                                >
                            </v-chip-group>
                        </v-row>
                    </v-container>

                    <v-row>
                        <v-col cols="2">
                            <v-row dense>
                                <v-col md="12">
                                    <w-text-field
                                        v-model="search"
                                        :label="$t('common.search')"
                                    />
                                </v-col>
                                <v-col md="12">
                                    <v-btn
                                        depressed
                                        color="teal"
                                        dark
                                        @click="save"
                                        block
                                        v-if="!single"
                                    >
                                        {{ $t("common.validate") }}
                                        <v-icon right>mdi-check-all</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="12">
                                    <v-btn depressed color="red" dark @click="close" block>
                                        {{ $t("common.cancel") }}
                                        <v-icon right>mdi-close</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="10">
                            <v-data-table
                                :headers="headers"
                                :search="search"
                                sort-by="code"
                                :items="paySectionStore.paySections"
                                :items-per-page="paySectionStore.paySections.length"
                                dense
                                class="elevation-3"
                                hide-default-footer
                                fixed-header
                                height="600"
                            >
                                <template v-slot:[`item.add`]="{ item }">
                                    <v-btn
                                        v-if="single"
                                        class="ma-1"
                                        x-small
                                        color="primary"
                                        @click="
                                              () => {
                                                selected.push({
                                                  ...item,
                                                  result: false
                                                });
                                                save();
                                              }
                                            "
                                    >
                                        selectionner
                                    </v-btn>
                                    <v-btn
                                        v-if="not_in(item) && !single"
                                        class="ma-1"
                                        x-small
                                        color="primary"
                                        @click="add(item, false)"
                                    >
                                        {{ $t("common.add") }}
                                    </v-btn>
                                    <v-btn
                                        v-if="is_in(item) && !single"
                                        class="ma-1"
                                        x-small
                                        color="red"
                                        dark
                                        @click="remove(item)"
                                    >
                                        {{ $t("common.remove") }}
                                    </v-btn>
                                </template>
                                <template v-slot:[`item.type`]="{ item }">
                                    {{ $t(`pay_section.type_${item.type}`) }}
                                </template>
                                <template v-slot:[`item.cotisable`]="{ item }">
                                    {{ $t(`pay_section.boolean_${item.cotisable}`) }}
                                </template>
                                <template v-slot:[`item.imposable`]="{ item }">
                                    {{ $t(`pay_section.imposable_${item.imposable}`) }}
                                </template>
                                <template v-slot:[`item.brute`]="{ item }">
                                    {{ $t(`pay_section.boolean_${item.brute}`) }}
                                </template>
                                <template v-slot:[`item.conge`]="{ item }">
                                    {{ $t(`pay_section.boolean_${item.conge}`) }}
                                </template>
                                <template v-slot:[`item.bulteinePrintable`]="{ item }">
                                    {{ $t(`pay_section.bulteine_printable_${item.bulteinePrintable}`) }}
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {usePaySectionStore} from "@/stores/PaySection";
import {ref} from "vue";
import useTools from "@/use/Tools";

export default {
    props: {
        selected: Array,
        object: Object,
        view: Boolean,
        dialog: Boolean,
        single: Boolean,
        disableSuggestion: Boolean,
    },
    setup(props, {emit}) {
        const {$i18n} = useTools();

        const paySectionStore = usePaySectionStore();

        const search = ref(null);
        const fullscreen = ref(false);
        const suggestionDialog = ref(false);
        const suggestions = ref([]);

        const headers = [
            {
                text: "...",
                align: "start",
                sortable: true,
                value: "add",
            },
            {
                text: $i18n.t("common.code"),
                align: "start",
                sortable: true,
                value: "code",
            },
            {
                text: $i18n.t("common.label"),
                align: "start",
                sortable: true,
                width: "300px",
                value: "label",
            },
            {
                text: $i18n.t("pay_section.type"),
                align: "start",
                sortable: true,
                value: "type",
            },
            {
                text: $i18n.t("pay_section.cotisable"),
                align: "start",
                sortable: true,
                value: "cotisable",
            },
            {
                text: $i18n.t("pay_section.imposable"),
                align: "start",
                sortable: true,
                width: "150",
                value: "imposable",
            },
            {
                text: $i18n.t("common.formula"),
                align: "start",
                sortable: false,
                width: "100px",
                value: "formule",
            },
            {
                text: $i18n.t("common.brute"),
                align: "start",
                sortable: true,
                value: "brute",
            },
            {
                text: $i18n.t("pay_section.holiday"),
                align: "start",
                sortable: true,
                value: "conge",
            },
            {
                text: $i18n.t("pay_section.printed"),
                align: "start",
                sortable: true,
                width: "150px",
                value: "bulteinePrintable",
            },
        ];

        function save() {
            emit("save");
        }

        function close() {
            emit("close");
        }

        function add(item, result) {
            props.selected.push({
                ...item,
                result: result,
                position: result ? 'RESULT' : null
            });
            if (!props.disableSuggestion) {
                if (item.relations.length > 0) {
                    item.relations.forEach((relation) => {
                        const relatedPaySection = paySectionStore.paySections.find((p) => p.code === relation.code);
                        if (relation.manualAdd) {
                            props.selected.push({
                                ...relatedPaySection,
                                result: result,
                                position: relation.position,
                            });
                        }
                    });
                } else {
                    paySectionStore.paySections.forEach((element) => {
                        if (element.formule) {
                            if (element.formule.includes(item.code)) {
                                const s = suggestions.value.find((e) => e.code === element.code);

                                if (!s)
                                    suggestions.value.push(element);
                            }
                        }
                    });

                    if (suggestions.value.length > 0)
                        suggestionDialog.value = true;
                }
            }
        }

        function remove(item) {
            props.selected.splice(props.selected.findIndex((ps) => ps.code === item.code), 1);
            if (item.relations.length > 0) {
                item.relations.forEach((relation) => {
                    if (relation.manualDelete) {
                        props.selected.splice(props.selected.findIndex((ps) => ps.code === relation.code), 1);
                    }
                });
            }
        }

        function is_in(item) {
            return props.selected.some((p) => p.code === item.code);
        }

        function not_in(item) {
            return !is_in(item);
        }


        return {
            paySectionStore,
            search,
            fullscreen,
            suggestions,
            suggestionDialog,
            headers,
            save,
            close,
            add,
            remove,
            is_in,
            not_in
        }
    }
};
</script>